export const PIECE_TYPE = {
    PAWN: 'p',
    KNIGHT: 'n',
    ROOK: 'r',
    BISHOP: 'b',
    QUEEN: 'q',
    KING: 'k'
};
const PIECE_TYPES = new Set(Object.values(PIECE_TYPE));
export const isPieceType = (value) => typeof value === 'string' && PIECE_TYPES.has(value);
export const PIECE_RARITY = {
    COMMON: 'COMMON',
    RARE: 'RARE',
    EPIC: 'EPIC'
};
//# sourceMappingURL=pieces.js.map